var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.time)?_c('vx-no-info-dash'):_c('div',[_c('div',[_vm._v(_vm._s(_vm.time))]),(_vm.lifetime)?_c('small',{staticClass:"font-weight-bolder"},[_vm._v(" ~ "+_vm._s(_vm.lifetime)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }